export const  autoPliotTypes = [
  'Base Autopilot',
  'Autopilot 1',
  'Autopilot 2 (Enhanced)',
  'Full Self-Driving',
  'HW-2.0',
  'HW-2.5',
  'HW-3.0',
  'Pre-Autopilot',
]
